import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Profile } from '@cemex-core/cmx-api/models/profiles-management/profile';
import { Store } from '@ngrx/store';
import { getSpecificationForm, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import {
  profilesWhenTechnicalProductIsNotPumpable,
  profilesWhenTechnicalProductIsPumpable,
} from '@ordersnproducts/modules/shared/utils/pumping-filters';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { hasDifferentToPumpRMXUL, hasPumpRMXUL } from '../../../helpers/should-hide-pump';

/**
 * Option loader to ask for the project profiles when the technical product is pumpable or not
 * but using the open plataform value added api (filter api)
 */
@Injectable()
export class PumpableProjectProfilesRMXULOptionLoader implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return combineLatest([
      this.store.select(getSpecificationForm),
      hasDifferentToPumpRMXUL(this.store, formGroup),
      hasPumpRMXUL(this.store, formGroup),
    ]).pipe(
      map(([state, hasDifferentToPumpOptions, hasPumpOption]) => {
        if (hasPumpOption && hasDifferentToPumpOptions) {
          return state.projectProfiles.map((profile: Profile) => {
            return {
              id: profile.profileId,
              name: profile.profileName,
            };
          });
        } else if (hasPumpOption && !hasDifferentToPumpOptions) {
          return profilesWhenTechnicalProductIsPumpable(state.projectProfiles).map((profile: Profile) => {
            return {
              id: profile.profileId,
              name: profile.profileName,
            };
          });
        } else {
          return profilesWhenTechnicalProductIsNotPumpable(state.projectProfiles).map((profile: Profile) => {
            return {
              id: profile.profileId,
              name: profile.profileName,
            };
          });
        }
      }),
    );
  }
}
